module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am478-a5dd94d4b6cca02f124e77dd9a457556.jpg";